<ciphr-collection-filter-header [attr.data-test-id]="filter().key" />

@if (expanded()) {
  <chr-input *transloco="let t"
             [clearable]="true"
             [hidden]="filter().values.length <= 10"
             icon="magnifier"
             [placeholder]="t('COMMON.PLACEHOLDERS.SEARCH')"
             size="s"
             [attr.data-test-id]="'inputOfSideFilterOption' + filter().key"
             (change)="search($event)" />

  <cdk-virtual-scroll-viewport itemSize="37">
    <chr-checkbox *cdkVirtualFor="let filterValue of filterValues()"
                  [checked]="selectedValues().has(filterValue.value)"
                  [attr.data-test-id]="'filterBy' + filterValue.value"
                  (change)="toggleValueSelection(filterValue.value)">
      <span ciphrTooltip [message]="filterValue.label">{{ filterValue.label }}</span>
    </chr-checkbox>
  </cdk-virtual-scroll-viewport>
}
